import { useNavigate } from 'react-router-dom';
import { AgentType } from '../interfaces/Agent';

const useNavigateToAgentDashboard = () => {
  const navigate = useNavigate();

  const navigateToAgentDashboard = (
    agentId?: string,
    agentType: AgentType = AgentType.CALL
  ) => {
    if (!agentId) return;
    if (agentType === AgentType.CALL) {
      navigate(`/agents/${agentId}`);
    } else {
      navigate(`/agents/chat/${agentId}`);
    }
  };

  return { navigateToAgentDashboard };
};

export default useNavigateToAgentDashboard;
